import { render, staticRenderFns } from "./HistoryText.vue?vue&type=template&id=68024f9a&"
import script from "./HistoryText.vue?vue&type=script&lang=js&"
export * from "./HistoryText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports